module.exports = __webpack_public_path__ + "static/media/01.adobe-illustrator.b2292487.svg";